import { useState, useRef, useEffect } from "react";
import NepaliDatePicker from '@zener/nepali-datepicker-react';
import '@zener/nepali-datepicker-react/index.css';
import "./Filters.css";

export default function MoneyFilters({
    filter,
    setFilter,
    userNames,
    onClear,
    rowsPerPage,
    setRowsPerPage,
    sortBy,
    setSortBy
}) {
    const [showSort, setShowSort] = useState(false);
    const sortRef = useRef(null);

    const sortOptions = [
        { label: "Date Added (Newest)", value: "created_desc" },
        { label: "Date (Newest)", value: "date_desc" },
        { label: "Date (Oldest)", value: "date_asc" },
        { label: "Amount (High → Low)", value: "amount_desc" },
        { label: "Amount (Low → High)", value: "amount_asc" }
    ];

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (sortRef.current && !sortRef.current.contains(e.target)) {
                setShowSort(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="filters-slim">
            <div className="row g-2 align-items-end">
                <div className="col-md-1">
                    <select className="form-select" value={rowsPerPage} onChange={e => setRowsPerPage(Number(e.target.value))}>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>

                <div className="col-md-2">
                    <select className="form-select" value={filter.type} onChange={e => setFilter(prev => ({ ...prev, type: e.target.value }))}>
                        <option>All</option>
                        <option>Debit</option>
                        <option>Credit</option>
                    </select>
                </div>

                <div className="col-md-2">
                    <select className="form-select" value={filter.user} onChange={e => setFilter(prev => ({ ...prev, user: e.target.value }))}>
                        <option value="All">All Users</option>
                        {userNames.map(u => <option key={u}>{u}</option>)}
                    </select>
                </div>

                <div className="col-md-2">
                    <NepaliDatePicker
                        value={filter.from ? new Date(filter.from) : null}
                        onChange={(date) => {
                            if (date) {
                                const regularDate = date.toADasDate ? date.toADasDate() : date;
                                const year = regularDate.getFullYear();
                                const month = String(regularDate.getMonth() + 1).padStart(2, '0');
                                const day = String(regularDate.getDate()).padStart(2, '0');
                                const localDateString = `${year}-${month}-${day}`;
                                setFilter(prev => ({ ...prev, from: localDateString }));
                            } else {
                                setFilter(prev => ({ ...prev, from: '' }));
                            }
                        }}
                        placeholder="From Date"
                        className="form-control"
                        type="BS"
                    />
                </div>

                <div className="col-md-2">
                    <NepaliDatePicker
                        value={filter.to ? new Date(filter.to) : null}
                        onChange={(date) => {
                            if (date) {
                                const regularDate = date.toADasDate ? date.toADasDate() : date;
                                const year = regularDate.getFullYear();
                                const month = String(regularDate.getMonth() + 1).padStart(2, '0');
                                const day = String(regularDate.getDate()).padStart(2, '0');
                                const localDateString = `${year}-${month}-${day}`;
                                setFilter(prev => ({ ...prev, to: localDateString }));
                            } else {
                                setFilter(prev => ({ ...prev, to: '' }));
                            }
                        }}
                        placeholder="To Date"
                        className="form-control"
                        type="BS"
                    />
                </div>

                <div className="col-md-2 position-relative" ref={sortRef}>
                    <button
                        className="filter-sort-btn w-100"
                        onClick={() => setShowSort(!showSort)}
                    >
                        <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style={{ marginRight: "6px" }}>
                            <path d="M3 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2z" />
                            <path d="M3 6h10v1H3zM3 10h10v1H3z" />
                        </svg>
                        Sort
                    </button>
                    {showSort && (
                        <div className="filter-sort-menu">
                            {sortOptions.map(opt => (
                                <div
                                    key={opt.value}
                                    className="filter-sort-item"
                                    onClick={() => {
                                        setSortBy(opt.value);
                                        setShowSort(false);
                                    }}
                                >
                                    {opt.label}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="col-md-1">
                    <button className="btn btn-outline-secondary w-100" onClick={onClear}>
                        Clear
                    </button>
                </div>
            </div>
        </div>
    );
}